module.exports = __webpack_public_path__ + "img/cql_logo.f5a0b185.svg";